export default __webpack_public_path__ + "static/media/glovo-sm-light.5c3cec82.svg";